<template>
  <div class="problem">
    <p class="name">用户手册</p>
    <div>
      <ul>
        <li v-for="item in helpCenter" :key="item.id" @click="onHelp(item)">
          <p>{{ item.name }}</p>
          <img src="../../assets/img/icon32.png">
        </li>
      </ul>
    </div>
    
  </div>
</template>

<script>
import { getCommonList } from '../../api/userMG'
export default {
  data() {
    return {
      helpCenter:[]
    }
  },

  created() {
    this.getHome();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    async getHome(){
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      await getCommonList({code:'yhsc'}).then(res => {
        // loading.close();
        console.log('数据',res);
        // 常见问题
        this.helpCenter = res.data
      })
      // .catch(err => {
      //   loading.close();
      // })
    },
    onHelp(item){
      // this.$emit('change',id,'用户手册')
      this.$router.push({path:'/index/supportDetail',query: { item: item,name:'用户手册'}})
    }
  }
}
</script>

<style scoped>
  .problem .name{
    font-family: SourceHanSansCN;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    border-left: 3px solid #f15903;
    padding-left: 10px;
    margin-bottom: 20px;
  }
  .problem ul li{
    height: 70px;
    border: 1px solid #E6E6E6;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    padding: 0 16px;
    background: #fff;
    cursor: pointer;
  }
  .problem ul li p{
    font-family: SourceHanSansCN;
    font-weight: 600;
    font-size: 14px;
    color: #333333;
  }
  .problem ul li img{
    width: 20px;
  }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/support/manual.vue